"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _GeometryRestrictionApi_geometryRestriction;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeometryRestrictionApi = void 0;
const AbstractRestrictionApi_1 = require("../AbstractRestrictionApi");
class GeometryRestrictionApi extends AbstractRestrictionApi_1.AbstractRestrictionApi {
    // #endregion Properties (1)
    // #region Constructors (1)
    constructor(restriction) {
        super(restriction);
        // #region Properties (1)
        _GeometryRestrictionApi_geometryRestriction.set(this, void 0);
        __classPrivateFieldSet(this, _GeometryRestrictionApi_geometryRestriction, restriction, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (6)
    get snapToEdges() {
        return __classPrivateFieldGet(this, _GeometryRestrictionApi_geometryRestriction, "f").snapToEdges;
    }
    set snapToEdges(value) {
        __classPrivateFieldGet(this, _GeometryRestrictionApi_geometryRestriction, "f").snapToEdges = value;
    }
    get snapToFaces() {
        return __classPrivateFieldGet(this, _GeometryRestrictionApi_geometryRestriction, "f").snapToFaces;
    }
    set snapToFaces(value) {
        __classPrivateFieldGet(this, _GeometryRestrictionApi_geometryRestriction, "f").snapToFaces = value;
    }
    get snapToVertices() {
        return __classPrivateFieldGet(this, _GeometryRestrictionApi_geometryRestriction, "f").snapToVertices;
    }
    set snapToVertices(value) {
        __classPrivateFieldGet(this, _GeometryRestrictionApi_geometryRestriction, "f").snapToVertices = value;
    }
    // #endregion Public Getters And Setters (6)
    // #region Public Methods (1)
    updateNodes(nodes) {
        __classPrivateFieldGet(this, _GeometryRestrictionApi_geometryRestriction, "f").updateNodes(nodes);
    }
}
exports.GeometryRestrictionApi = GeometryRestrictionApi;
_GeometryRestrictionApi_geometryRestriction = new WeakMap();
//# sourceMappingURL=GeometryRestrictionApi.js.map